/* eslint-disable no-plusplus */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Chest = function (scene, x, y) {
  this.scene = scene;
  this.x = x;
  this.y = y;
  this.chest = null;
  this.chestEmpty = null;
  this.chestFull = null;
  this.isBlocked = false;
};
/**
 *
 */
EDC.Animations.Chest.prototype.create = function () {
  this.chest = this.scene.add.sprite(this.x, this.y, 'chest-closed');

  this.chestEmpty = this.scene.add.sprite(this.x, this.y, 'chest-empty');
  this.chestEmpty.setAlpha(0);

  this.chestFull = this.scene.add.sprite(this.x, this.y, 'chest-full-2');
  this.chestFull.setAlpha(0);
};
/**
 *
 */
EDC.Animations.Chest.prototype.playEmpty = function () {
  if (this.isBlocked) return;
  this.chest.setAlpha(0);
  this.chestEmpty.setAlpha(1);
  this.generateSpiders();
  this.scene.time.addEvent({
    delay: 1000,
    callback: () => {
      this.chestEmpty.setAlpha(0);
      this.chest.setAlpha(1);
    },
    callbackScope: this,
  });
};
/**
 *
 */
EDC.Animations.Chest.prototype.generateSpiders = function () {
  const allData = [
    {
      angle: 200, sx: -100, sy: -30, x: -50, y: 150, time: 500,
    },
    {
      angle: 180, sx: 0, sy: -30, x: 0, y: 200, time: 800,
    },
    {
      angle: 140, sx: 130, sy: -30, x: 60, y: 150, time: 650,
    },
  ];

  for (let i = 0; i < allData.length; i++) {
    const data = allData[i];
    const spider = this.scene.add.sprite(this.chestEmpty.x + data.sx, this.chestEmpty.y + data.sy, 'spider');
    spider.setAngle(data.angle);
    this.scene.tweens.add({
      targets: spider,
      x: spider.x + data.x,
      y: spider.y + data.y,
      alpha: 0.4,
      duration: data.time,
      ease: 'Linear',
      onComplete: function (spiderSprite) {
        spiderSprite.destroy();
      }.bind(this, spider),
    });
  }
};
/**
 *
 */
EDC.Animations.Chest.prototype.playFull = function () {
  this.chest.setAlpha(0);
  this.chestEmpty.setAlpha(0);
  this.chestFull.setAlpha(1);
  this.isBlocked = true;
};

EDC.Animations.Chest.prototype.destroyChest = function () {
  this.chest.destroy();
  this.chestEmpty.destroy();
  this.chestFull.destroy();
  this.chest = null;
  this.chestEmpty = null;
  this.chestFull = null;
};

export default EDC.Animations.Chest;
